import { alpha, useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, ListItem } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import { SimSliderContainer } from 'components/SimSlider';
import { CheckIcon } from 'components/icons/CheckIcon';

const slides = [
	{
		headerTitle: 'Why is Speech & Language therapy needed?',
		subTitles: [
			'Speech and language delays tend to be among parents’ earliest developmental concerns. Speech & Language therapy is perceived as supporting the literal act of speaking. It has other important aspects like comprehension, clarity, voice, fluency, and sound production.'
		],

		bodyTitle: 'Our program helps with:',
		bulletOptions: [
			'PracReceptive and expressive communication challenges',
			'Oral motility concerns – chewing, swallowing etc.',
			'Voice fluency, articulation and social language skills.'
		],

		CTAType1: 'CTA',
		CTAText1: 'Schedule Session',
		CTALink1: '/contact'
	}
];

const SpeechLangTherapyDescription = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0,
				'&::after': {
					position: 'absolute',
					content: '""',
					width: '30%',
					zIndex: 1,
					top: 0,
					right: 0,
					height: '100%',
					backgroundSize: '18px 18px',
					backgroundImage: `radial-gradient(${alpha(theme.palette.primary.dark, 0.4)} 20%, transparent 20%)`,
					opacity: 0.2
				}
			}}>
			<Box
				position={'relative'}
				zIndex={2}
				marginX={{ xs: 'auto', sm: 'auto', md: '0px' }}
				display={'flex'}
				flexDirection={'column'}
				alignItems={'center'}>
				<SimSliderContainer
					maxWidth={{ xs: '74vw', sm: '90vw', md: '80vw', lg: '80vw' }}
					slideProps={{ marginX: 'auto', paddingX: 'auto', marginY: 0, paddingY: 0 }}
					dotSx={{ marginTop: { xs: 10, sm: 7, md: 7, lg: 4 } }}
					prevSx={{ width: 62 }}
					nextSx={{ width: 62 }}>
					{slides.map((item, idx) => (
						<Card
							key={idx}
							sx={{
								display: 'flex',
								flexDirection: {
									xs: 'column',
									md: (idx + 1) % 2 === 0 ? 'row' : 'row-reverse'
								},
								boxShadow: 0,
								background: 'transparent'
							}}>
							<CardContent
								sx={{
									display: 'flex',
									alignItems: 'left',
									marginLeft: { sx: 0, md: 2 }
								}}>
								<Box>
									<Box marginBottom={2}>
										<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
											{item.headerTitle}
										</SimTypography>
										<SimTypography color='text.primary' sx={{ mb: 5 }}>
											{item.subTitles?.length &&
												item.subTitles.map(subTitle => <Box> {subTitle}</Box>)}
										</SimTypography>
									</Box>

									<Grid container spacing='2px'>
										<SimTypography>{item.bodyTitle}</SimTypography>

										{item.bulletOptions.map((option, idx) => (
											<Grid item xs={12} key={idx}>
												<Box
													component={ListItem}
													disableGutters
													width={'auto'}
													padding={0}
													margin={0}
													display={'flex'}
													flexDirection={'row'}
													alignItems={'flex-start'}
													justifyItems={'left'}>
													<CheckIcon marginTop={'0.6em'} />
													<SimTypography padding={'7px'}>{option}</SimTypography>
												</Box>
											</Grid>
										))}
									</Grid>
									<Box display={'flex'} justifyContent={'flex-end'}>
										<SimButton
											variant='contained'
											backgroundColor={
												item.CTAType1 === 'CTA'
													? theme.palette.background.btnPrimaryCTA
													: theme.palette.background.btnSecondaryCTA
											}
											color={
												item.CTAType1 === 'CTA'
													? theme.palette.text.btnPrimaryCTA
													: theme.palette.text.btnSecondaryCTA
											}
											href={item.CTALink1}>
											{item.CTAText1}
										</SimButton>
									</Box>
								</Box>
							</CardContent>
						</Card>
					))}
				</SimSliderContainer>
			</Box>
		</Box>
	);
};

export { SpeechLangTherapyDescription };
